module.exports = __webpack_public_path__ + "static/media/MedicationConsentForm.1cab4b9c.pdf";